import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableActions from "./table-actions";
import { NoData } from "src/shared/components/tables/no-data";
import { TableLoadingSkeleton } from "src/shared/components/tables/table-loading-skeleton";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import Link from "@mui/material/Link";
import AmountType from "./amount-type";
import { getReferenceRoute } from "src/utils";

const EventTable = ({
  data,
  isFetching,
  refetch,
}: {
  data: any;
  isFetching: boolean;
  refetch: Function;
}) => {
  const emptyDataArr = data?.length === 0;
  const { t } = useTranslation("purchasing");
  const { t: generalT } = useTranslation("general");

  const HeadText = [
    t("reference"),
    t("eventType"),
    t("from"),
    t("to"),
    t("date"),
    t("total"),
    t("used"),
    t("invoiceRef"),
    t("note"),
    t("by"),
    t("createdAt"),
    t("actions"),
  ];

  const typeMap: Record<string, string> = {
    liability: generalT("expenses"),
    vendor: generalT("vendor"),
    other_revenue: generalT("otherRevenue"),
    fixed_asset: generalT("fixedAsset"),
    inventory: generalT("inventory"),
  };

  const operationMap: Record<string, string> = {
    advanced: t("advancePayment"),
    received: t("paymentReceive"),
    government_tax: t("dueToGovernmentTax"),
    to_account: `${t("to")} ${t("expensesAccount")}`,
    from_account: `${t("from")} ${t("expensesAccount")}`,
  };

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            {HeadText.map((item) => (
              <TableCell
                key={item}
                align={"center"}
                sx={{
                  bgcolor: "#F9FAFB",
                }}
              >
                <Typography
                  fontSize={"12px"}
                  color={"#475467"}
                  lineHeight={"18px"}
                  fontWeight={500}
                >
                  {item}
                </Typography>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        {isFetching ? (
          <TableLoadingSkeleton rowsLength={15} cellsLength={12} />
        ) : (
          <TableBody>
            {data?.map((row: any) => {
              const type = typeMap[row?.type] || t(row?.type);
              const isSupplierOrLiability =
                row.type === "supplier" || row.type === "liability";
              const operation = row.operation;
              const typeDescription =
                operationMap[operation] || t("settlement");
              return (
                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  key={row.id}
                >
                  <TableCell align="center">{row.reference}</TableCell>
                  <TableCell align="center">
                    {row.type_label}
                    {/* {`${type} ${
                    isSupplierOrLiability ? `- ${typeDescription}` : ""
                  }`} */}
                  </TableCell>
                  <TableCell align="center">{row.from}</TableCell>
                  <TableCell align="center">{row.to}</TableCell>
                  <TableCell align="center">{row.date}</TableCell>
                  <TableCell align="center">{row.amount}</TableCell>
                  <TableCell align="center">{row.used}</TableCell>
                  <TableCell align="center">
                    {row.references &&
                      String(row.references)
                        .split(",")
                        .map((r: string) => r.trim())
                        .filter(Boolean)
                        .map((ref: string, index: number, arr: string[]) => (
                          <span key={ref}>
                            <Link
                              component={RouterLink}
                              to={getReferenceRoute(ref)}
                              underline="always"
                              sx={{ fontSize: "inherit" }}
                            >
                              {ref}
                            </Link>
                            {index !== arr.length - 1 ? ", " : ""}
                          </span>
                        ))}
                  </TableCell>
                  <TableCell align="center">{row.note}</TableCell>
                  <TableCell align="center">{row.created_by}</TableCell>
                  <TableCell align="center">{row.created_at}</TableCell>
                  <TableCell align="right">
                    <TableActions row={row} refetch={refetch} />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        )}
      </Table>
      {emptyDataArr && <NoData />}
    </TableContainer>
  );
};
export default EventTable;
